<app-sidebar></app-sidebar>
<div class="content">
	<router-outlet></router-outlet>
	<app-admin-actions *ngIf="!environment.production"></app-admin-actions>
</div>
